export default __webpack_public_path__ + "static/media/imagotipo.b3ae5ed1.svg";